/* Kiraal eigen winkelwagen-drawer - vervangt AMP Slide Cart */
(function () {
  var TIMER_MINUTES = 10;
  var TIMER_KEY = 'kc_timer_end';

  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ---------- Oude Slide Cart-app onschadelijk maken ----------
  // De app laadt via een eigen script op elk thema (ook als hij hier uit staat) en kan onzichtbaar
  // openen en de pagina op slot zetten. Tot de app verwijderd is sluiten we hem direct.
  function ourDrawerOpen() {
    var d = document.getElementById('sidebar-cart');
    return d && d.getAttribute('aria-hidden') === 'false';
  }
  function killSlideCart() {
    try {
      if (typeof window.SLIDECART_STATE === 'function' && window.SLIDECART_STATE().open && window.SLIDECART_CLOSE) {
        window.SLIDECART_CLOSE();
      }
    } catch (e) {}
    if (!ourDrawerOpen()) {
      if (document.body && document.body.style.overflow === 'hidden') document.body.style.overflow = '';
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.overflow = '';
    }
  }
  setInterval(killSlideCart, 250);
  document.addEventListener('click', function () { setTimeout(killSlideCart, 50); setTimeout(killSlideCart, 400); }, true);

  // ---------- Verzendverzekering nergens als 'product' tonen ----------
  // Verbergt de verzekering in 'Misschien vind je dit ook leuk' (en andere productlijsten)
  // en in de 'kocht zojuist een'-meldingen van de Autoketing Sales Pop-app.
  var HIDE_HANDLE = 'verzendverzekering';
  var HIDE_TITLE = 'verzendverzekering';
  function hideProtection(root) {
    root = root || document;
    var links = root.querySelectorAll ? root.querySelectorAll('a[href*="/products/' + HIDE_HANDLE + '"]') : [];
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.closest('#sidebar-cart')) continue;
      var card = a.closest('.Grid__Cell, .ProductItem, .Carousel__Cell, li');
      if (card && !card.closest('#sidebar-cart')) card.style.display = 'none';
    }
    var pops = document.querySelectorAll('[class*="Autoketing-Sales-Pop-Master"]');
    for (var j = 0; j < pops.length; j++) {
      var p = pops[j];
      var has = (p.textContent || '').toLowerCase().indexOf(HIDE_TITLE) > -1;
      if (has && p.getAttribute('data-kc-hidden') !== '1') {
        p.style.setProperty('display', 'none', 'important');
        p.setAttribute('data-kc-hidden', '1');
      } else if (!has && p.getAttribute('data-kc-hidden') === '1') {
        p.style.removeProperty('display');
        p.removeAttribute('data-kc-hidden');
      }
    }
  }
  var hpQueued = false;
  new MutationObserver(function () {
    if (hpQueued) return; hpQueued = true;
    setTimeout(function () { hpQueued = false; hideProtection(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('DOMContentLoaded', function () { hideProtection(); });


  // ---------- 'Kocht zojuist'-pop-up (vervangt Autoketing Sales Pop) ----------
  // Instellingen overgenomen uit Autoketing: linksonder, alleen desktop, eerste na 5s,
  // 15s zichtbaar, 25s ertussen, max 30 per pagina, nieuwste eerst. Toont alleen woonplaats.
  (function () {
    var SP = { delay: 5, show: 15, gap: 25, max: 30, minWidth: 768 };
    if (window.innerWidth < SP.minWidth) return;
    var css = '[class*="Autoketing-Sales-Pop"]{display:none!important}' +
      '.ksp{position:fixed;left:20px;bottom:20px;z-index:2147483000;width:360px;max-width:calc(100vw - 40px);display:flex;gap:12px;align-items:center;' +
      'background:rgba(164,164,164,.96);color:#fff;border-radius:6px;padding:10px 34px 10px 10px;box-shadow:0 6px 24px rgba(0,0,0,.18);' +
      'text-decoration:none;opacity:0;transform:translateY(16px);transition:opacity .35s ease,transform .35s ease;pointer-events:none}' +
      '.ksp.is-on{opacity:1;transform:none;pointer-events:auto}' +
      '.ksp__img{flex:0 0 70px;width:70px;height:70px;object-fit:contain;background:#fff;border-radius:4px}' +
      '.ksp__txt{min-width:0;display:flex;flex-direction:column;gap:3px;line-height:1.25}' +
      '.ksp__title{font-size:13px;color:#fff}.ksp__name{font-size:16px;font-weight:700;color:#fff;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.ksp:hover .ksp__name{text-decoration:underline}.ksp__time{font-size:12px;color:#fff;opacity:.9}' +
      '.ksp__close{position:absolute;top:6px;right:8px;background:none;border:0;color:#fff;font-size:18px;line-height:1;cursor:pointer;padding:2px}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

    function cityCase(c) {
      return String(c || '').toLowerCase().replace(/(^|[\s\-'])([a-zà-ÿ])/g, function (m, a, b) { return a + b.toUpperCase(); });
    }
    function ago(iso) {
      var m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
      if (m < 2) return 'zojuist';
      if (m < 60) return m + ' minuten geleden';
      var h = Math.round(m / 60);
      if (h < 24) return h + (h === 1 ? ' uur' : ' uur') + ' geleden';
      var d = Math.round(h / 24);
      return d + (d === 1 ? ' dag' : ' dagen') + ' geleden';
    }
    function closedForSession() { try { return sessionStorage.getItem('ksp_closed') === '1'; } catch (e) { return false; } }

    fetch('/?view=salespop', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var list = [];
        try { list = JSON.parse(t); } catch (e) { return; }
        list = list.filter(function (x) { return x && x.t && x.title && x.title.toLowerCase().indexOf('verzendverzekering') === -1; })
                   .sort(function (a, b) { return new Date(b.t) - new Date(a.t); });
        if (!list.length || closedForSession()) return;

        var el = document.createElement('a');
        el.className = 'ksp'; el.setAttribute('aria-live', 'polite');
        el.innerHTML = '<img class="ksp__img" alt=""><span class="ksp__txt"><span class="ksp__title"></span><span class="ksp__name"></span><span class="ksp__time"></span></span><button type="button" class="ksp__close" aria-label="Sluiten">&times;</button>';
        document.body.appendChild(el);
        el.querySelector('.ksp__close').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          el.classList.remove('is-on'); stopped = true;
          try { sessionStorage.setItem('ksp_closed', '1'); } catch (x) {}
        });

        var idx = 0, shown = 0, stopped = false;
        try { idx = (parseInt(sessionStorage.getItem('ksp_idx'), 10) || 0) % list.length; } catch (e) {}
        function next() {
          if (stopped || shown >= SP.max) return;
          var it = list[idx % list.length];
          idx++; shown++;
          try { sessionStorage.setItem('ksp_idx', String(idx % list.length)); } catch (e) {}
          el.href = it.url;
          var img = el.querySelector('.ksp__img');
          if (it.img) { img.src = it.img; img.style.display = ''; } else { img.style.display = 'none'; }
          el.querySelector('.ksp__title').textContent = 'Iemand uit ' + cityCase(it.c) + ' kocht zojuist een:';
          el.querySelector('.ksp__name').textContent = it.title;
          el.querySelector('.ksp__time').textContent = ago(it.t);
          el.classList.add('is-on');
          setTimeout(function () {
            el.classList.remove('is-on');
            setTimeout(next, SP.gap * 1000);
          }, SP.show * 1000);
        }
        setTimeout(next, SP.delay * 1000);
      })
      .catch(function () {});
  })();

  // ---------- Afteltimer ----------
  function getEnd() {
    var end = 0;
    try { end = parseInt(sessionStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + TIMER_MINUTES * 60 * 1000;
      try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  var timerEnd = getEnd();
  function tick() {
    var els = document.querySelectorAll('[data-kc-countdown]');
    if (!els.length) return;
    var left = timerEnd - Date.now();
    if (left <= 0) { timerEnd = getEnd(); left = timerEnd - Date.now(); }
    var s = Math.floor(left / 1000);
    var txt = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);

  // ---------- Aantal in titel bijwerken na herladen ----------
  function syncCount() {
    var form = document.querySelector('#sidebar-cart form.Cart');
    var target = document.querySelector('[data-kc-title-count]');
    if (!form || !target) return;
    var n = parseInt(form.getAttribute('data-kc-count'), 10) || 0;
    target.textContent = n > 0 ? n : '';
    tick();
  }
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer) return;
    new MutationObserver(syncCount).observe(drawer, { childList: true, subtree: false });
    var cartEl = drawer.querySelector('form.Cart');
    if (cartEl && cartEl.parentNode) new MutationObserver(syncCount).observe(cartEl.parentNode, { childList: true });
    syncCount();
  });

  // ---------- Upsells ----------
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-kc-upsell-select]');
    if (!sel) return;
    var box = sel.closest('[data-kc-upsell]');
    var opt = sel.options[sel.selectedIndex];
    box.querySelector('[data-kc-add]').setAttribute('data-kc-add', sel.value);
    var price = box.querySelector('[data-kc-upsell-price]');
    if (price && opt) price.textContent = opt.getAttribute('data-price');
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    post('/cart/add.js', { items: [{ id: parseInt(btn.getAttribute('data-kc-add'), 10), quantity: 1 }] })
      .then(refreshCart)
      .catch(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });

  // ---------- Verzendverzekering ----------
  document.addEventListener('change', function (e) {
    var sw = e.target.closest && e.target.closest('[data-kc-protection]');
    if (!sw) return;
    var id = parseInt(sw.getAttribute('data-kc-protection'), 10);
    sw.disabled = true;
    var req = sw.checked
      ? post('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : post('/cart/update.js', { updates: (function () { var u = {}; u[id] = 0; return u; })() });
    req.then(refreshCart).catch(function () { sw.disabled = false; });
  });
})();
